<template>
    <div>
      <div
        class="div">
        <div
          class="container"
        >
        <div class="zong">
        <iframe ref="myIframe" id="myIframe" scrolling="no" frameborder="0" style="width: 100%; height: 100%;" src="/html/linianwenhua.html"></iframe>
        </div>
          </div>
          </div>
          
    </div>
  </template>
  
  <script>
  export default {
    name: "ProductDetail",
    data() {
      return {
        
      };
    },
    methods: {
        sendMessageToIframe: function(data){
          const iframe = this.$refs.myIframe;
          // 使用 postMessage 发送数据给 iframe
          iframe.contentWindow.postMessage(data, "*");
      },
    },
    mounted() {
        setTimeout(()=>{
            var data = JSON.parse(window.localStorage.getItem("productdetail"));
        this.sendMessageToIframe(data)
        },1000)
    },
  };
  </script>
  
  <style scoped lang="less">
  .zong {
  width: 75%;
  margin-left: 12%;
  margin-top: 6vw;
  margin-bottom: 8vw;
}
  </style>
  